import React, { ErrorInfo, ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
  errorId: string | null;
}

export class AppErrorBoundary extends React.Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  public state: AppErrorBoundaryState = {
    hasError: false,
    errorId: null,
  };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return {
      hasError: true,
      errorId: `err-${Date.now()}`,
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[AppErrorBoundary] Render crash recovered", {
      error,
      componentStack: errorInfo.componentStack,
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          background:
            "linear-gradient(180deg, rgba(244, 239, 230, 0.95) 0%, rgba(255, 255, 255, 1) 100%)",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "560px",
            padding: "32px",
            borderRadius: "24px",
            background: "rgba(255, 255, 255, 0.94)",
            border: "1px solid rgba(32, 45, 66, 0.12)",
            boxShadow: "0 18px 48px rgba(32, 45, 66, 0.12)",
            color: "#1f2937",
          }}
        >
          <p
            style={{
              margin: "0 0 12px",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#9a6700",
            }}
          >
            Recovery Mode
          </p>
          <h1
            style={{
              margin: "0 0 12px",
              fontSize: "32px",
              lineHeight: 1.1,
            }}
          >
            The app hit an unexpected render error.
          </h1>
          <p
            style={{
              margin: "0 0 16px",
              fontSize: "16px",
              lineHeight: 1.6,
              color: "#4b5563",
            }}
          >
            The screen has been recovered instead of leaving a blank page. Reload
            the app to continue the demo.
          </p>
          <p
            style={{
              margin: "0 0 24px",
              fontSize: "14px",
              color: "#6b7280",
            }}
          >
            Reference: {this.state.errorId}
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "12px 20px",
              fontSize: "15px",
              fontWeight: 600,
              color: "#ffffff",
              background: "#1d4ed8",
              cursor: "pointer",
            }}
          >
            Reload App
          </button>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
